var _link, _link2, _style, _style2, _style3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJpeg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Joint Photographic Experts Group logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.69 -42.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vlpa",
    transform: "matrix(.2646 0 0 .2646 17.55 14.17)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "jpeg-text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m212.8 401.7c-9.104 0-15.59-0.375-15.59-0.375v-45.65h15.5c17.19 0 28.15 4.765 28.15 20.59 0 13.44-4.75 25.43-28.06 25.43m0.41-57.27h-28.56v109.2h12.56v-40.39h18.41c25.74 0 38.03-15.83 38.03-35.86 0-20.4-12.58-32.91-40.45-32.91",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.3 404.1h44.24v-11.72h-44.24v-36.83h51.23v-11.09h-63.79v107.2h65.94v-11.1h-53.38z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m399.5 395v10.88h18.61v26.94c-5.697 8.471-20.96 8.471-20.96 8.471-11.62 0-21-3.998-27.83-12.09-6.779-8.056-10.2-16.72-10.2-29.74 0-13.68 3.391-24.19 10.27-32.6 6.957-8.416 16.62-13.07 28.62-13.07 6.152 0 12.76 1.895 19.2 5.848l7.762-8.692c-6.949-5.724-15.82-8.568-26.57-8.568-16.02 0-28.96 5.223-38.35 15.59-9.489 10.34-14.3 24.1-14.3 40.9 0 16.81 4.408 29.51 13 39.64 8.531 9.988 20.51 15.12 35.23 15.12 6.637 0 13.45-0.625 20.54-2.844 5.463-1.726 7.342-3.121 15.52-3.121v-52.66z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m144.9 344.5h-8.424v11.09h8.424v51.57c0 15.9 0.475 25.21-4.98 30.67-3.409 3.451-8.319 5.303-12.5 5.303-19.66 0-20.38-15.76-20.38-15.76h-12.06c1.153 28.04 34.11 26.18 34.11 26.18 8.764-0.465 15.7-3.354 21.11-8.781 7.154-7.209 7.324-20.54 7.324-31.67v-68.6z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m339.8 107h-206.3v206.2h119.4v-86.81h86.97z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 349.7,
    y: 238,
    width: 75.28,
    height: 75.32,
    fill: "#000"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpeg);
export default __webpack_public_path__ + "static/media/Jpeg.792e4c1cd301ae3971775ce23593916d.svg";
export { ForwardRef as ReactComponent };